enum BrowserButtonType {
    CLOSE = "close",
    HOUSING = "housing",
    FULLSIZE = "fullsize"
}

export default BrowserButtonType;
